module.exports = __webpack_public_path__ + "static/Faktum-Medium.6025c4b5.otf";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/_fonts/Faktum-Medium.otf
// module id = 431
// module chunks = 114276838955818